<template>

    <div class="col-3">
        <div class="card text-center">
            <div class="card-body">
                <div class="mb-4">
                    <h1 class="mb-2" style="font-size: 3rem; color: #0A3764"><i
                            :class="'bi bi-' + (stat.category?.icon ?? '')"></i></h1>
                    <h2 class="mb-1">{{ stat.category?.label }}</h2>
                </div>
                <h2 class="mb-1" style="font-size: 3rem">{{ stat.total }}</h2>
                <small class="card-subtitle">Plaintes</small>

                <a class="stretched-link" href="#"></a>
            </div>

            <div class="card-footer">
                <div class="row col-divider">
                    <div class="col">
                        <span class="h4">{{ stat.not_affected }}</span>
                        <span class="d-block fs-5" style="white-space: nowrap;">Non affectées</span>
                    </div>

                    <div class="col">
                        <span class="h4">{{ stat.affected }}</span>
                        <span class="d-block fs-5">Affectées</span>
                    </div>

                    <div class="col">
                        <span class="h4">{{ stat.closed }}</span>
                        <span class="d-block fs-5">Clôturées</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name:"StatsCard",
    props:{
        stat:{
            required:true,
            type:Object
        }
    }
}
</script>